import React, { Fragment, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import ShiftInfoAdmin from './ShiftInfoAdmin';
import DatePicker from 'react-date-picker';
import NewShift from './NewShift';


import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table'
import '../css/table-styles.css'


const ShiftListAll = ({ is_admin }) => {

    const [shifts, setShifts] = useState([]);
    const [display_shifts, setDisplay_shifts] = useState([]);

    const [filter_worker, setFilter_worker] = useState("")
    const [filter_client, setFilter_client] = useState("")
    const [filter_date, setFilter_date] = useState("")
    const [filter_km, setFilter_km] = useState("")
    const [filter_expenses, setFilter_expenses] = useState(false)
    const [filter_shift_id, setFilter_shift_id] = useState("")

    const getShifts = async () => {
        try {
            const response = await fetch("https://www.beyondcommunityaccess.com/shifts/all", {
                method: "GET",
                headers: { token: localStorage.token }
            });
            const jsonDataReq = await response.json();

            var jsonData = jsonDataReq.rows;

            jsonData.sort((a, b) => {
                var dif = parseInt(b.start_time) - parseInt(a.start_time);
                if (dif == 0) {
                    return parseInt(b.end_time) - parseInt(a.end_time);
                } else {
                    return dif;
                }
            });

            jsonData.map(shift => {
                if (shift.has_expenses) {
                    shift.has_expenses_display = "Present"
                } else {
                    shift.has_expenses_display = "Vacant"
                }
                var temp_date = new Date(parseInt(shift.start_time));
                shift.start_time_display = temp_date.toLocaleString();


                temp_date = new Date(parseInt(shift.end_time));
                shift.end_time_display = temp_date.toLocaleString();

                shift.duration = shift.end_time - shift.start_time
                temp_date = new Date(parseInt(shift.duration));
                shift.duration_display = temp_date.toLocaleString();

                temp_date = new Date(parseInt(shift.duration / 60000));
                shift.duration_display = Math.floor(temp_date / 60) + " hours, " + temp_date % 60 + " minutes"

                shift.description_display = shift.description.substring(0, 10);
                if (shift.description.length > 10) {
                    shift.description_display += '...'
                }
            })

            setShifts(jsonData);
            setDisplay_shifts(jsonData);

        } catch (err) {
            console.error("Failed: getting all a user's shifts");
            console.error(err.message);
        }
    }

    const deleteShift = async (shift_id) => {

        const body = { shift_id }
        const response = await fetch("https://www.beyondcommunityaccess.com/shifts/delete", {
            method: "DELETE",
            headers: { "Content-Type": "application/json", token: localStorage.token },
            body: JSON.stringify(body)
        });

        getShifts();
    }

    function filter() {
        try {
            setDisplay_shifts(shifts.filter(shift => {
                var pass = true;
                if (filter_shift_id != "") {
                    if (!shift.shift_id.toLowerCase().includes(filter_shift_id.toLocaleLowerCase())) {
                        pass = false
                    }
                }
                if (filter_worker != "") {
                    if (!shift.worker_name.toLowerCase().includes(filter_worker.toLocaleLowerCase()) && !shift.worker_id.toLowerCase().includes(filter_worker.toLocaleLowerCase())) {
                        pass = false
                    }
                }

                if (filter_client != "") {
                    if (!shift.name.toLowerCase().includes(filter_client.toLocaleLowerCase()) && !shift.client_id.toLowerCase().includes(filter_client.toLocaleLowerCase())) {
                        pass = false
                    }
                }
                if (filter_date != "" && filter_date != null) {
                    if (parseInt(shift.start_time) < filter_date.getTime()) {
                        pass = false;
                    }
                }
                if (filter_km != "") {
                    if (parseInt(shift.m_travelled) < filter_km) {
                        pass = false;
                    }
                }
                if (filter_expenses) {
                    if (!shift.has_expenses) {
                        pass = false;
                    }
                }
                return pass;
            }))

        } catch (err) {
            console.error("Couldn't filter all shifts")
            console.error(err.message)
        }

    }

    useEffect(() => {
        getShifts();
    }, [])

    useEffect(() => {
        filter();
    }, [filter_worker, filter_client, filter_date, filter_km, filter_expenses, filter_shift_id])
    return (
        <Fragment>
            <div className="container-fluid">
                <h1 className="m-2">Total Shift List</h1>
                {is_admin==2 && <NewShift refresh_shifts={getShifts}/>}
                <h5 className="ml-2">Filters:</h5>
                <input className="form-control m-1" type="text" placeholder="Worker" value={filter_worker} onChange={e => setFilter_worker(e.target.value)} />
                <input className="form-control m-1" type="text" placeholder="Client" value={filter_client} onChange={e => setFilter_client(e.target.value)} />
                <input className="form-control m-1" type="text" placeholder="Shift_id" value={filter_shift_id} onChange={e => setFilter_shift_id(e.target.value)} />
                <p> Start date: </p><DatePicker onChange={setFilter_date} value={filter_date} />
                <input className="form-control m-1" type="number" placeholder="Minimum Kilometres" value={filter_km} onChange={e => setFilter_km(e.target.value)} />

                <input placeholder="Expenses" type="checkbox" className="form-check-input ml-2 mt-2" id="expenses_filter_check" value={filter_expenses} onChange={e => setFilter_expenses(e.target.checked)} />
                <label className="form-check-label ml-5 mt-1" htmlFor="viewer_filter_check">
                    Has Expenses
                </label>

                <p className="text-danger">Deleting shifts will inform the worker. It will also delete any related expenses and their proof. The proof image will be lost forever.</p>
                <Table className="table text-center mt-2">
                    <Thead>
                        <Tr>
                            <Th>Internal Shift ID</Th>
                            <Th>Worker Name</Th>
                            <Th>Client Name</Th>
                            <Th>Start Time</Th>
                            <Th>End Time</Th>
                            <Th>Duration</Th>
                            <Th>Kilometres Travelled</Th>
                            <Th>Has Expenses</Th>
                            <Th>Description</Th>
                            <Th>Expand</Th>
                            {is_admin == 2 && <Th>Delete</Th>}
                        </Tr>
                    </Thead>
                    <Tbody>
                        {/* <Tr>
                        <Td>John</Td>
                        <Td>Doe</Td>
                        <Td>john@example.com</Td>
                    </Tr> */}
                        {display_shifts.map(shift => (
                            <Tr key={shift.shift_id}>
                                <Td>{shift.shift_id}</Td>
                                <Td>{shift.worker_name}</Td>
                                <Td>{shift.name}</Td>
                                <Td>{shift.start_time_display}</Td>
                                <Td>{shift.end_time_display}</Td>
                                <Td>{shift.duration_display}</Td>
                                <Td>{shift.m_travelled}</Td>
                                <Td>{shift.has_expenses_display}</Td>
                                <Td>{shift.description_display}</Td>
                                <Td><ShiftInfoAdmin shift={shift} /></Td>
                                {is_admin == 2 && <Td><button className="btn btn-danger" onClick={(e) => { e.preventDefault(); deleteShift(shift.shift_id) }}>Delete</button></Td>}

                            </Tr>
                        ))}
                    </Tbody>
                </Table>
            </div>
        </Fragment>
    );
}

export default ShiftListAll;

// const body = { temp_worker_id, client, start, end, expenses, m_travelled, description };
